import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Log de débogage pour vérifier le chargement
console.log('📦 index.js chargé');
console.log('📦 React version:', React.version);
console.log('📦 ReactDOM disponible:', !!ReactDOM);

// Service Worker COMPLÈTEMENT DÉSACTIVÉ - Ne jamais enregistrer
// Désactiver TOUS les Service Workers existants IMMÉDIATEMENT
if ('serviceWorker' in navigator) {
  // Désactiver immédiatement au chargement
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister().then((success) => {
        if (success) {
          console.log('✅ Service Worker désactivé:', registration.scope);
        }
      }).catch((error) => {
        console.error('Erreur désactivation Service Worker:', error);
      });
    }
  });
  
  // Empêcher tout nouvel enregistrement
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.warn('⚠️ Tentative d\'enregistrement Service Worker détectée, rechargement...');
    window.location.reload();
  });
  
  // Intercepter les tentatives d'enregistrement
  const originalRegister = navigator.serviceWorker.register;
  navigator.serviceWorker.register = function() {
    console.warn('⚠️ Tentative d\'enregistrement Service Worker bloquée');
    return Promise.reject(new Error('Service Worker désactivé'));
  };
}

// Vérifier que le DOM est prêt
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('❌ Élément #root introuvable dans le DOM !');
  document.body.innerHTML = '<div style="padding: 20px; color: red; font-size: 20px;">Erreur: élément #root introuvable</div>';
} else {
  console.log('✅ Élément #root trouvé, montage de React...');
  
  // Rendre directement l'application
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log('✅ ReactDOM.createRoot créé');
    
    console.log('🚀 Montage de l\'application complète...');
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('✅ Application React montée');
    
  } catch (error) {
    console.error('❌ Erreur lors du montage React:', error);
    rootElement.innerHTML = `
      <div style="padding: 20px; color: red; font-size: 18px;">
        <h1>Erreur de chargement</h1>
        <p>${error.message}</p>
        <pre style="background: #f0f0f0; padding: 10px; overflow: auto;">${error.stack}</pre>
        <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 10px; cursor: pointer;">Recharger</button>
      </div>
    `;
  }
}
